













import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Company, AddCompany } from '../store/company'
import CompanyForm from './CompanyForm.vue'

const company = namespace('company')

@Component({ components: { CompanyForm } })
export default class AddCompanyModal extends Vue {
  @company.Action addCompany!: (company: AddCompany) => Promise<Company>
  @company.Action loadCompanies!: () => void
  dialog = false

  async add(input: AddCompany) {
    await this.addCompany(input)
    await this.loadCompanies()
    // router.push({ name: 'company' })
    this.dialog = false
  }
}
